import { useParams, useSearchParams } from 'react-router-dom';

import { OrganizationCreateInvitationPage } from '~/components/pages/OrganizationCreateInvitationPage';
import { DashboardTemplate } from '~/components/templates/DashboardTemplate';
import { Navigate } from '~/components/utils/Navigation';

export const OrganizationCreateInvitationRoute: React.FC = () => {
  const { organizationId } = useParams();
  const [searchParams] = useSearchParams();

  if (!organizationId) {
    return <Navigate to="/" />;
  }

  return (
    <DashboardTemplate organizationId={organizationId}>
      <OrganizationCreateInvitationPage
        organizationId={organizationId}
        previousUrl={searchParams.get('previousUrl') ?? undefined}
        nextUrl={searchParams.get('nextUrl') ?? undefined}
        cancelUrl={searchParams.get('cancelUrl') ?? undefined}
      />
    </DashboardTemplate>
  );
};
